import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card, Button, Form, Alert, Spinner } from "react-bootstrap"; // Import Bootstrap components

const AppVersion = () => {
  const [platform, setPlatform] = useState("Android");
  const [latestVersion, setLatestVersion] = useState("");
  const [downloadUrl, setDownloadUrl] = useState("");
  const [releaseNotes, setReleaseNotes] = useState("");
  const [isMandatory, setIsMandatory] = useState(false);
  const [versionData, setVersionData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Get the API URL from environment variables
  const MOBILE_API_URL =
    process.env.REACT_APP_MOBILE_API_URL ||
    "https://selfcare.americanholdings.lk"; // Fallback URL if not set
  const token = localStorage.getItem("authToken");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchCurrentVersion();
  }, [platform]);

  const fetchCurrentVersion = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${MOBILE_API_URL}/api/AppVersion?platform=${platform}`,
      );
      if (response.data) {
        setVersionData(response.data);
        setLatestVersion(response.data.version);
        setDownloadUrl(response.data.downloadUrl);
        setReleaseNotes(response.data.releaseNotes);
        setIsMandatory(response.data.isMandatory);
      }
    } catch (error) {
      console.error("Error fetching app version:", error);
      setError("Failed to fetch version information.");
    }
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const payload = {
      platform,
      latestVersion: latestVersion,
      downloadUrl,
      releaseNotes,
      isMandatory,
      releaseDate: new Date().toISOString(),
    };
    try {
      await axios.post(`${MOBILE_API_URL}/api/AppVersion`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      alert("Version updated successfully");
      fetchCurrentVersion(); // Refresh the version data after updating
    } catch (error) {
      console.log("Authorization Header:", {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      });
      console.error("Error updating version:", error);
      setError("Failed to update version. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div className="container my-5">
      <h2 className="mb-4">App Version Manager</h2>

      {error && <Alert variant="danger">{error}</Alert>}

      <Card className="p-4 shadow-sm">
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="platformSelect" className="mb-3">
            <Form.Label>Platform</Form.Label>
            <Form.Control
              as="select"
              value={platform}
              onChange={(e) => setPlatform(e.target.value)}
            >
              <option value="Android">Android</option>
              <option value="IOS">IOS</option>
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="latestVersion" className="mb-3">
            <Form.Label>Latest Version</Form.Label>
            <Form.Control
              type="text"
              value={latestVersion}
              onChange={(e) => setLatestVersion(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group controlId="downloadUrl" className="mb-3">
            <Form.Label>Download URL</Form.Label>
            <Form.Control
              type="url"
              value={downloadUrl}
              onChange={(e) => setDownloadUrl(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group controlId="releaseNotes" className="mb-3">
            <Form.Label>Release Notes</Form.Label>
            <Form.Control
              as="textarea"
              value={releaseNotes}
              onChange={(e) => setReleaseNotes(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group controlId="isMandatory" className="mb-3">
            <Form.Check
              type="checkbox"
              label="Mandatory Update"
              checked={isMandatory}
              onChange={(e) => setIsMandatory(e.target.checked)}
            />
          </Form.Group>

          <Button
            type="submit"
            variant="primary"
            className="w-100"
            disabled={loading}
          >
            {loading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              "Update Version"
            )}
          </Button>
        </Form>
      </Card>

      <div className="mt-4">
        <h3>Current Version Information</h3>
        {versionData ? (
          <Card className="p-4 shadow-sm">
            <p>
              <strong>Platform:</strong> {platform}
            </p>
            <p>
              <strong>Version:</strong> {versionData.version}
            </p>
            <p>
              <strong>Download URL:</strong>{" "}
              <a
                href={versionData.downloadUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {versionData.downloadUrl}
              </a>
            </p>
            <p>
              <strong>Release Notes:</strong> {versionData.releaseNotes}
            </p>
            <p>
              <strong>Mandatory:</strong>{" "}
              {versionData.isMandatory ? "Yes" : "No"}
            </p>
          </Card>
        ) : (
          <p>Loading current version information...</p>
        )}
      </div>
    </div>
  );
};

export default AppVersion;
